import React, { useEffect, useState } from "react";
import Home from "../Home";
import { Progress } from "../dimensions";
import * as image from "../../resources/images";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsersDetail, userCoupanOffer } from "../../redux/actions/APIs";
import { showModal } from "../../redux/actions";
const DisCountOfferPopup = ({ closePopup }) => {
    const dispatch = useDispatch();
    const { response, defaultChildData, loggedInUser, userCoupanResp } = useSelector(
        (state) => state.collections
    );

    const [discountValue, setDisCountValue] = useState("25%");
    const [loader, setLoader] = useState(false);
    const [isSuccess, SetIsSuccess] = useState(false);
    const [disCountType, setDisCountType] = useState("Yearly");
    // console.log("loggedInUser @@@ : ",discountValue ,loggedInUser);
    const handdlleDisCount = () => {
        let obj = {
            coupan: discountValue,
            isSelected: true,
        };
        // console.log("handdlleDisCount : ", obj);
        setLoader(true);
        dispatch(userCoupanOffer(loggedInUser?.id, obj));
    };

    useEffect(() => {
        if (userCoupanResp?.success) {
            setLoader(false);
            dispatch(userCoupanOffer());
            dispatch(getAllUsersDetail());
            closePopup();
            return;
        }
    }, [userCoupanResp]);

    const handleContinue = () => {
        dispatch(showModal({ type: "DimensionHintPopup" }));
    }
    // console.log("discountValue : ", discountValue);
    return (
        <div className="smallpopup ondiscountpopup newuipopupchanges RootContent">
            <div className="modal d-flex" id="schoolactivity7" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content my_popup p-0">
                        <div className="modal-body paymentinfo p-0">
                            <div className="discount_poup flexone">
                                <div className="leftSidepop">
                                    <img src={image.Image_Placeholder} />
                                </div>
                                <div className="rightsidepop">
                                    <div className={`mytabList  twotabs`}>
                                        <ul className="flexthree">
                                            <li className={`w-50 text-center ${disCountType === "Yearly" && " Active_tab"}`} onClick={() => setDisCountType("Yearly")}>
                                                Yearly
                                            </li>
                                            <li className={`w-50 text-center ${disCountType === "Monthly" && " Active_tab "} "}`} onClick={() => setDisCountType("Monthly")}>
                                                Monthly
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="">
                                        <div class="Ansoptions">
                                            <label class={`selAnslabel ${discountValue === "50%" && "Active_discount"} `}>
                                                <div className="discountcrd">
                                                    <p className="flexone">
                                                        <span className="dispercent">50% Discount</span>   <span className="discounamount"> <strong>{disCountType === "Monthly" ? "$14.99" : "$12.49"}</strong> / month</span>
                                                    </p>
                                                    <p className="billedperyear flexone"><span>Billed {disCountType}</span>{disCountType === "Yearly" && (<span>$149.99 / year</span>)}</p>
                                                </div>
                                                <input
                                                    type="radio"
                                                    id={"option1"}
                                                    name={"option1"}
                                                    defaultChecked={discountValue === "50%"}
                                                    onClick={() => setDisCountValue("50%")}
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="Ansoptions">
                                            <label class={`selAnslabel ${discountValue === "25%" && "Active_discount"} `}>
                                                <div className="discountcrd">
                                                    <p className="flexone">
                                                        <span className="dispercent">25% Discount</span> <span className="discounamount"> <strong>{disCountType === "Monthly" ? "$22.49" : "$18.75"}</strong> / month</span>
                                                    </p>
                                                    <p className="billedperyear flexone"><span>Billed {disCountType}</span>{disCountType === "Yearly" && (<span>$224.99 / year</span>)}</p>
                                                </div>
                                                <input type="radio"
                                                    id={"option1"}
                                                    name={"option1"}
                                                    defaultChecked={discountValue === "25%"}
                                                    onClick={() => setDisCountValue("25%")} />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="benifits pt-3">
                                        <p className="p3 mb-3">Added Benefits:</p>
                                        <ul>
                                            {disCountType === "Yearly" && (
                                                <li className="flexthree"><i class="fa-solid fa-check mr-1"></i>For one full year on any plan</li>
                                            )}
                                            {disCountType === "Monthly" && (
                                                <li className="flexthree"><i class="fa-solid fa-check mr-1"></i>For one full month on any plan</li>
                                            )}
                                            {discountValue === "25%" && (
                                                <>
                                                    <li className="flexthree"><i class="fa-solid fa-check mr-1"></i>Complete one (1) course and do one (1) 30-minute feedback call.</li>
                                                </>
                                            )}
                                            {discountValue === "50%" && (
                                                <>
                                                    <li className="flexthree"><i class="fa-solid fa-check mr-1"></i>Complete one (2) course and do one (2) 30-minute feedback call.</li>
                                                </>
                                            )}

                                        </ul>
                                    </div>
                                    <div className="modal-footer mt-3 pt-3">
                                        <div class="BDsubmitbutton flexone" >
                                            <a href="javascript:void(0);" className="mr-3" onClick={() => handleContinue()}>Continue With Free</a>
                                            <button type="submit" class="btn-blue btn-login d-block mb-5  "
                                                onClick={() => handdlleDisCount()}
                                            >
                                                Subscribe To {discountValue} off
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DisCountOfferPopup;